(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-market-leader-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const refinement = new URLSearchParams(window.location.search).get('cc_hero_refinement');
    const allowedRefinements = ['current', 'a', 'b', 'c'];
    if (!allowedRefinements.includes(refinement)) return;

    document.querySelectorAll('.cc-market-leader-hero[data-opus-refinement]').forEach((hero) => {
      hero.dataset.opusRefinement = refinement;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
